<template>
  <v-card class="mx-auto" v-if="papers">
    <v-toolbar
      color="indigo lighten-2"
      dark>
      <v-toolbar-title>{{ $vuetify.lang.t(title) }}</v-toolbar-title>
    </v-toolbar>

    <v-list color="grey lighten-5">
      <template v-for="(year, index) in years">
        <div :key="year">
          <v-divider v-if="index !== 0"></v-divider>
          <v-subheader>{{ year }}</v-subheader>
          <v-list-item v-for="(paper, paperIndex) in papers[year]" :key="`paper_${year}_${paperIndex}`" selectable>
            <v-list-item-icon>{{ numeration(paperIndex, year) + 1 }}.</v-list-item-icon>
            <v-list-item-content>
              <span v-html="paper.title"></span>
            </v-list-item-content>
          </v-list-item>
        </div>
      </template>
    </v-list>
  </v-card>

</template>

<script>
export default {
  name: 'papersList',
  props: {
    title: String,
    papers: Object
  },
  computed: {
    years () {
      return Object.keys(this.papers).sort((a, b) => b - a)
    }
  },
  methods: {
    numeration (index, sectionYear) {
      let sum = 0
      for (const year of this.years.filter(year => sectionYear < year)) {
        sum += this.papers[year].length
      }

      return sum + index
    }
  }
}
</script>

<style scoped>

</style>
